import Header from './Header';

const LoginOtp = () => {
    return (
        <div className="best">
            <Header />
         <div className="bredcrub">
            <div className="container">
                <ul>
                    <li><a href="#">Home</a></li> <i className="fa-solid fa-angle-right"></i>
                    <li><a href="#">Register</a></li>
                </ul>
            </div>
        </div>
        <div className="verifybox">
            <h2>Verify It's You</h2>
            <p>An email with a verification link has<br/> been sent to your Email ID.</p>
            <button>Open email app</button>
        </div>
        </div>
    );
};
  
export default LoginOtp;